import { getModulePath, LEAGUE_MODULE_NAMES } from "@leagueplatform/core";
import { Navigate, useLocation, useParams } from "react-router-dom";

export const LEGACY_ABOUT_ME_PATH = "/member/about-me";

export const LegacyAboutMeRedirect = () => {
  const { search, hash } = useLocation();
  const subPath = useParams()["*"];
  const aboutMePath = getModulePath(LEAGUE_MODULE_NAMES.aboutMe);

  return (
    <Navigate
      to={{
        pathname: subPath ? `${aboutMePath}/${subPath}` : aboutMePath,
        search,
        hash,
      }}
      replace
    />
  );
};
